import axios from "/@/utils/request";

const api = {
  getSeatUserList: "/console/v1/seatUser/list",
  addSeat: "/console/v1/seatUser/create",
  bind: "/console/v1/seatUser/bind/socialAccount",
  editSeat: "/console/v1/seatUser/update",
};

const getSeatList = (params: any) => {
  return axios({
    url: api.getSeatUserList,
    method: "get",
    params,
  });
};
const postAddSeat = (data: any) => {
  return axios({
    url: api.addSeat,
    method: "post",
    data,
  });
};
const postEditSeat = (data: any) => {
  return axios({
    url: api.editSeat,
    method: "post",
    data,
  });
};
// 绑定社媒账号
const postBindAccount = (data: any) => {
  return axios({
    url: api.bind,
    method: "post",
    data,
  });
};
export { getSeatList, postAddSeat, postBindAccount, postEditSeat };
